// src/utils/jobCosts.js
// S6B VERIFIER: s6costing-4d8a2f63 — security audit 2026-10-02 #2.
//
// Labour COST rates (each worker's laborCostRate / wage) no longer live on the job's
// jobCosting.laborEntries rows. They live in organizations/{orgId}/jobCosts/{jobId}
// = { rates: { [userId]: number } }, written only by Cloud Functions
// (functions/utils/jobCosts.js) and readable only by Owner / Admin / Manager
// (firestore.rules) — founder decision, Marcus 2026-10-04.
//
// The rows keep userId / name / hours / source / allocatedHours: they are the crew and
// hours record, visible to the whole crew. Only the money moved.
//
// NEVER copy a rate from this map back onto a row: rows are saved straight from the
// browser by the job editor and the calendar, and a rate written there would be stripped
// by the server anyway. Look rates up at render time with rateForRow().

// The high-level role list lives in ONE place (permissions.js, mirror of rules isHighLevel()).
import { HIGH_LEVEL_ROLES } from './permissions';
export { HIGH_LEVEL_ROLES };

// May this user see labour COST (cost rates and labour-cost totals)? Bill-out amounts are
// not pay and keep their own VIEW_FINANCIALS gate.
export const canSeeLaborCost = (profile) => !!profile && HIGH_LEVEL_ROLES.includes(profile.role);

// The cost rate for one labour row: the stored jobCosts rate, or undefined. Returns whatever the
// caller's existing arithmetic expects to parseFloat — `parseFloat(rateForRow(e, rates)) || 0`.
// s9costs-2b8f6d14 — S9a (S6b follow-up a): the fallback to the row's own legacy `rate` is gone.
// All 10 orgs are migrated (0 rows carry a rate) and every report figure was proven IDENTICAL
// without it (compareReportTotals --no-row-fallback, 2026-10-05). A rate a client types onto a
// row is therefore never shown as a cost.
export const rateForRow = (entry, rates) => {
    if (entry && entry.userId && rates && Object.prototype.hasOwnProperty.call(rates, entry.userId)) {
        return rates[entry.userId];
    }
    return undefined;
};

// A display-only copy of a job's rows with each row's cost rate resolved. For READ-ONLY
// report maths; never save the result.
export const rowsWithCostRates = (entries, rates) =>
    (Array.isArray(entries) ? entries : []).map((e) => (e ? { ...e, rate: rateForRow(e, rates) } : e));
